import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import classNames from "classnames";

import styles from "./Navigation.css";

class SearchWindow extends Component {
  constructor(props, context) {
    super(props, context);

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);

    this.state = {
      search: null,
    };
  }

  componentDidMount() {
    this.searchInput.focus();
  }

  handleChange(event) {
    this.setState({ search: event.target.value });
  }

  handleSubmit(e) {
    e.preventDefault();

    if (this.state.search) {
      this.props.onHideSearch();
      this.props.history.push({ pathname: "/results", search: this.state.search });
    }
  }

  render() {
    return (
      <form onSubmit={this.handleSubmit}>
        <div role="search" className={classNames(styles.searchWindow, this.props.isCompressed ? styles.mobileSearchWindow : null)}>
          <input
            ref={(input) => { this.searchInput = input }}
            aria-label="Search Axios"
            onChange={this.handleChange}
            className={styles.bottomLineInputs} placeholder="Search Axios" />
        </div>
      </form>
    );
  }
}

export default withRouter(SearchWindow);
